import { http } from "api/http";

const getTanClientsCredentials = ({ queryKey }: any) => {
  return http.get("/incometaxtan/credentials", { params: { ...queryKey[1] } });
};

const exportIncomeTaxTanClients = (data: any) => {
  return http.post("/incometaxtan/client-credentialsexport", data);
};

const addTanClientCredentials = (data: any) => {
  return http.post("/incometaxtan/credentials", data);
};

const getAllClients = ({ queryKey }: any) => {
  return http.get("incometaxtan/clients", { params: { ...queryKey[1] } });
};

const updateTanClientCredentials = ({ id, data }: any) => {
  return http.put(`/incometaxtan/credentials/${id}`, data);
};

const getIncomeTaxProfile = ({ queryKey }: any) => {
  return http.get(`incometaxtan/profile/${queryKey[1]}`);
};

const createRequest = ({ id, data }: any) => {
  return http.post(`/tan-sync/auto-machine/${id}`, data);
};

//ALL CLIENT RELATED
const getTanClientEchallan = ({ queryKey }: any) => {
  return http.get(`incometaxtan/clientechallan/${queryKey[1]}`, { params: queryKey[2] });
};

//SINGLE CLIENT
const getEChallanData = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/e-challan/${queryKey[1]}`);
};

const getClientTanPortalCredential = ({ queryKey }: any) => {
  console.log(queryKey)
  return http.get(`/incometaxtan/credential/${queryKey[1]}`, { params: { clientId: queryKey[1] } });
};

//ALL CLIENTS
const getIncomeTaxEchallans = ({ queryKey }: any) => {
  return http.get("/incometaxtan/e-challans", { params: { ...queryKey[1] } });
};
const exportTanClientChallan = (data: any) => {
  return http.post("/incometaxtan/tanClientChallan-export", data);
};

const exportTanIncomeTaxChallans = (data: any) => {
  return http.post("/incometaxtan/e-challans-export", data);
};

//SINGLE CLIENT
const getFormData = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/form/${queryKey[1]}`);
};

//ALL CLIENT RELATED
const getClientForm = ({ queryKey }: any) => {
  return http.get(`incometaxtan/clientform/${queryKey[1]}`, { params: queryKey[2] });
};

//ALL CLIENTS
const getIncomeTaxForms = ({ queryKey }: any) => {
  return http.get("/incometaxtan/forms", { params: { ...queryKey[1] } });
};

const getActivityLogData = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/activity/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const getIncomeTaxReports = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/reports`, { params: { ...queryKey[1] } });
};

const exportTanSyncStatus = (data: any) => {
  return http.post("/incometaxtan/exportTanSyncStatus-export", data);
};
const exportTanClientForm = (data: any) => {
  return http.post("/incometaxtan/tanClientForm-export", data);
};

const exportTanIncomeTaxForms = (data: any) => {
  return http.post("/incometaxtan/forms-export", data);
};

const exportTanIncomeTaxReports = (data: any) => {
  return http.post("/incometaxtan/lastSync-export", data);
};

const getClientAutoStatus = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/clientAutoStatus/${queryKey[1]}`);
};

//MY CHARTARED ACCOUNTANTS
const getIncomeTaxMycas = ({ queryKey }: any) => {
  return http.get("incometaxtan/my-cas", { params: { ...queryKey[1] } });
};
const exportTanIncomeTaxMycas = (data: any) => {
  return http.post("/incometaxtan/myCas-export", data);
};

const getMyCaFormTypes = () => {
  return http.get(`incometaxtan/form-types`);
};

const getClientMycas = ({ queryKey }: any) => {
  return http.get(`incometaxtan/mycas/${queryKey[1]}`, { params: queryKey[2] });
};
const exportTanClientMyCas = (data: any) => {
  return http.post("/incometaxtan/tanMyCas-export", data);
};

//UPDATES

const getIncomeTaxNewUpdates = () => {
  return http.get(`/tan-sync/new-updates`);
};

const getNewUpdateItem = ({ queryKey }: any) => {
  return http.get(`/tan-sync/update/${queryKey[1]}`);
};

//Traces
const getClientTraceCommunication = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/traces-communication/${queryKey[1]}`, { params: queryKey[2] });
};
const exportClientTanTracesInbox = (data: any) => {
  return http.post("/incometaxtan/clientTanTraces-export", data);
};
const getAllTraceCommunications = ({ queryKey }: any) => {
  return http.get("/incometaxtan/traces-communications", { params: { ...queryKey[1] } });
};
const exportClientTracesInbox = (data: any) => {
  return http.post("/incometaxtan/clientTraces-export", data);
};


const getActivityLogTracesData = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/activity-traces/${queryKey[1]}`, { params: { ...queryKey[2] } });
};

const getClientAutoTracesStatus = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/clientAutoStatus-traces/${queryKey[1]}`);
};

const getTraceReports = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/traces-reports`, { params: { ...queryKey[1] } });
};
const exportTanTraceSyncStatus = (data: any) => {
  return http.post("/incometaxtan/exportTanTraceSyncStatus-export", data);
};

const getTanTempNoticeFyi = ({ queryKey }: any) => {
  return http.get("/incometaxtan/temp-notice-fyi", { params: { ...queryKey[1] } });
};

const getTanTempNoticeFya = ({ queryKey }: any) => {
  return http.get("/incometaxtan/temp-notice-fya", { params: { ...queryKey[1] } });
};

const getClientExcelproceedingFyi = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/clientproceedingfyi-excel/${queryKey[1]}`, {
    params: queryKey[2], // Passing query parameters
  });
};

const getClientExcelproceedingFya = ({ queryKey }: any) => {
  console.log('getClientExcelproceedingFya', queryKey)
  return http.get(`/incometaxtan/clientproceedingfya-excel/${queryKey[1]}`, { params: queryKey[2] });
};

const getExcelFyiSections = () => {
  return http.get(`/incometaxtan/sections-fyi-excel`);
};

const getExcelFyaSections = () => {
  return http.get(`/incometaxtan/sections-fya-excel`);
};

const getExcelEproceedingNotice = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/eproceeding-notice-excel`, { params: { ...queryKey[1] } });
};

const getIncomeTaxDemands = ({ queryKey }: any) => {
  return http.get("/incometaxtan/demands", { params: { ...queryKey[1] } });
};

const getDemandData = ({ queryKey }: any) => {
  return http.get(`/incometaxtan/demand/${queryKey[1]}`);
};

const getClientDemand = ({ queryKey }: any) => {
  return http.get(`incometaxtan/clientDemand/${queryKey[1]}`, { params: queryKey[2] });
};

const exportTracesIncomeTaxDemands = (data: any) => {
  return http.post("/incometaxtan/demands-export", data);
};

const exportTracesclientDemand = (data: any) => {
  return http.post("/incometaxtan/export-clientdemand", data);
};

export {
  exportTanTraceSyncStatus,
  exportTanSyncStatus,
  exportClientTanTracesInbox,
  exportClientTracesInbox,
  exportTanIncomeTaxReports,
  exportTanIncomeTaxForms,
  exportTanIncomeTaxMycas,
  exportTanIncomeTaxChallans,
  exportTanClientMyCas,
  exportTanClientForm,
  exportTanClientChallan,
  exportIncomeTaxTanClients,
  addTanClientCredentials,
  getTanClientsCredentials,
  getAllClients,
  updateTanClientCredentials,
  getIncomeTaxProfile,
  createRequest,
  getTanClientEchallan,
  getEChallanData,
  getIncomeTaxEchallans,
  getFormData,
  getClientForm,
  getIncomeTaxForms,
  getActivityLogData,
  getIncomeTaxReports,
  getClientAutoStatus,
  getIncomeTaxMycas,
  getMyCaFormTypes,
  getClientMycas,
  getIncomeTaxNewUpdates,
  getNewUpdateItem,
  getClientTraceCommunication,
  getAllTraceCommunications,
  getActivityLogTracesData,
  getClientAutoTracesStatus,
  getTraceReports,
  getTanTempNoticeFyi,
  getTanTempNoticeFya,
  getExcelFyiSections,
  getExcelFyaSections,
  getClientExcelproceedingFyi,
  getClientExcelproceedingFya,
  getExcelEproceedingNotice,
  getIncomeTaxDemands,
  getDemandData,
  getClientDemand,
  exportTracesIncomeTaxDemands,
  exportTracesclientDemand,
  getClientTanPortalCredential
};
